import { memo, useEffect, useState } from 'react';
import { Network } from '@kattana-io/common';
import IconProvider from '../../helpers/IconProvider';
import useIcon from '../PairIcons/useIcon';
import Image, { imageSizeType } from '../../atoms/Image';
import NumberDisplay from '../NumberDisplay';

import fallbackIcon from '../PairIcons/icons/placeholder.svg';

import './styles.scss';

interface ITokenInfoProps {
  chain: string;
  address: string;
  name?: string;
  amount?: number;
  textSize?: number;
  textWeight?: number;
  imageSize?: imageSizeType;
  icon?: string;
}

const TokenInfo = ({
  chain,
  address,
  name = '',
  amount,
  textSize = 12,
  textWeight = 400,
  imageSize = 'l',
  icon,
}: ITokenInfoProps) => {
  const [error, setError] = useState(false);

  let iconSrc = icon;

  if (!iconSrc) {
    const network = Network.fromChain(chain);
    if (network) {
      iconSrc = IconProvider.createFromNetworkAndPair(network, address).url();
    } else {
      iconSrc = fallbackIcon;
    }
  }

  useEffect(() => {
    setError(false);
  }, [iconSrc]);

  const path = useIcon(iconSrc, error, !!iconSrc);

  return (
    <div className='token_info'>
      {path && (
        <Image
          className='token_info__icon'
          alt={`${chain}/${address}`}
          src={error ? fallbackIcon : path}
          onError={() => setError(true)}
          size={imageSize}
        />
      )}

      <NumberDisplay
        value={amount}
        startSymbol={`${name} `}
        zeroValueDisplay={name}
        textProps={{
          size: textSize,
          className: `token_info__meta text--weight-${textWeight}`,
          style: { title: `${name} ${amount || ''}` },
        }}
      />
    </div>
  );
};

export default memo(TokenInfo);
